import React from "react";
import cx from "clsx";
import styles from "../scss/MobileNav.module.scss";
import Button from "../../Shared/Button";
import ContactInfo from "./ContactInfo";
import { Link, useLocation } from "react-router-dom";

const MobileNav = ({ active, setActive }) => {
  const location = useLocation();
  const navList = [
    {
      label: "Acasă",
      to: "/",
      match: ["/"],
    },
    {
      label: "Servicii",
      to: "/servicii",
      match: ["/servicii"],
    },
    {
      label: "Tratamente",
      to: "/tratamente",
      match: ["/tratamente"],
    },
    {
      label: "Tarife",
      to: "/tarife",
      match: ["/tarife"],
    },
    {
      label: "Recenzii",
      to: "/recenzii",
      match: ["/recenzii"],
    },
  ];
  return (
    <>
      {active && <div className={styles.navLayout}></div>}
      <div className={cx(styles.navListContainer, active && styles.active)}>
        <p className={styles.closeButton} onClick={() => setActive(false)}>
          X
        </p>
        <div className={styles.logoContainer}>
          <img src="/images/logo.jpeg" alt="" />
        </div>
        <ul className={styles.navList}>
          {navList.map((item) => (
            <li
              className={cx(
                item.match.includes(location.pathname) && styles.active
              )}
            >
              <Link to={item.to} onClick={() => setActive(false)}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <Button
          className={styles.appointmentButton}
          onClick={() => setActive(false)}
        >
          <Link to="/programare">Fă o Programare</Link>
        </Button>
        <ContactInfo />
      </div>
    </>
  );
};

export default MobileNav;
